<template>
  <div id="app">
    <Header />
    <div class="content">
      <transition name="fade" mode="out-in">
        <router-view/>
      </transition>
    </div>
    <Footer />
  </div>
</template>

<script>
import { detect } from 'detect-browser';
import MobileDetect from 'mobile-detect';
import Header from 'components/header/Header';
import Footer from 'components/footer/Footer';
import { mapMutations } from 'vuex';

const browser = detect();
const md = (typeof window !== 'undefined')
  ? new MobileDetect(window.navigator.userAgent)
  : null;

export default {
  components: {
    Header,
    Footer,
  },

  created() {
    this.setAdaptive();
    if (browser) {
      this.setBrowser(browser.name);
    }
  },

  methods: {
    ...mapMutations({
      setBrowser: 'CHANGE_BROWSER',
      setDevice: 'SET_DEVICE',
    }),

    setAdaptive() {
      if (!md) return;
      if (!md.mobile()) {
        this.setDevice('desktop');
      }
      if (md.phone()) {
        this.setDevice('phone');
      }
      if (md.tablet()) {
        this.setDevice('tablet');
      }
    },
  },
};
</script>

<style lang="scss">
  @import "./assets/scss/reset.scss";
  @import "./assets/scss/vars.scss";
  @import "./assets/scss/common.scss";
  .content{
    min-height: calc(100vh - 30px);

    @media only screen and (max-width : $phone){
      min-height: initial;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue